export enum ManifestControlTarget {
    invoiceReference = 'InvoiceReferenceEnabled',
    contractAccountNumber = 'ContractAccountNumberEnabled'
}

export enum ManifestConfigurationContext {
    BorrowerApplication,
    BrokerBorrowerApplication
}
